import ArchiveProgramCategory from './Main'
import { getBaseMetaTitle } from '@/environments'

const route = {
  path: '/archive/program/:year/:categoryName',
  name: 'programArchiveCategory',
  meta: {
    title: `Archive - ${getBaseMetaTitle}`
  },
  component: ArchiveProgramCategory
}

export default route
